import FormControl from '@mui/material/FormControl';
import TextField from "@mui/material/TextField";
import { InputAdornment } from '@mui/material';
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from '@mui/material';
import Popover from '@mui/material/Popover';
import { useState, useEffect } from 'react';
import React from "react";
import { IFormField } from '../../shared/globalTypes';

export type Props = {
    id?: string,
    type?: 'text' | 'textarea' | 'number' | 'password',
    name: string,
    value?: string,
    label: string,
    min?: number,
    defaultValue?: string,
    max?: number,
    rows?: number,
    multiline?: boolean,
    required?: boolean,
    disabled?: boolean,
    readOnly?: boolean,
    error?: boolean,
    errorText?: string,
    infoText?: string,
    onFocus?: React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined,
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined,
    onBlur?: (event: React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined, formField: IFormField) => void
    onClick?: React.MouseEventHandler<HTMLDivElement> | undefined,
};

export const DataField = (dataFieldProps: Props) => {

    const { id, label, name, value, type, multiline, disabled, rows, readOnly, required, error, infoText, onBlur, onFocus, onChange, onClick, defaultValue} = dataFieldProps;
    
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [viewInfo, setViewInfo] = useState(false);
    const [displayInfoIcon, setDisplayInfoIcon] = useState(false);
    const [isError, setIsError] = useState(error);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        setErrorMsg('');
        setIsError(false);
    }, [disabled]);

    useEffect(() => {
        if (infoText) setDisplayInfoIcon(true);
    }, []);

    useEffect(() => {
        setRequiredError(error);
    }, [error]);

    const infoPopup = (event: React.MouseEvent<HTMLButtonElement>) => {
        setViewInfo(true);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setViewInfo(false);
    };

    const setRequiredError = (error: boolean | undefined) => {
        setIsError(error);
        (error) ? setErrorMsg('Field is required') : setErrorMsg('');
    }

    const onHandleBlur = (event : {}) => {
        const e = event as React.FocusEvent<HTMLInputElement>;        
        ((value == "" || !value) && (required)) ? setRequiredError(true) : setRequiredError(false);
    }

    const iconAdornment = displayInfoIcon
        ? {
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={infoPopup}
                        edge="end"
                    >
                        <InfoIcon />
                    </IconButton>
                </InputAdornment>
            )
        }
        : {};

    return (
        <FormControl fullWidth>
            <TextField fullWidth
                label={label}
                name={name}
                value={value}
                type={type || undefined}
                disabled={disabled}
                multiline={multiline}
                rows={rows || undefined}
                error={isError}
                required={required}
                helperText={errorMsg}
                variant={readOnly ? 'standard' : 'outlined'}
                InputProps={{...iconAdornment, readOnly: readOnly, id: id}}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onHandleBlur}
                onClick={onClick}
                defaultValue={defaultValue}
                // { (field) ? onBlur={(e) => onHandleBlur(e, field): return; }
            />
            {viewInfo && <Popover
                open={true}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <div style={{ padding: 10 }}>{infoText}</div>
            </Popover>}
        </FormControl>
    );
}


export default DataField;